import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

// LOCAL IMPORTS
import { Header } from '@/components/Shared/Header';
import { SideMenuDesktop } from '@/components/Shared/SideMenu';
import { PasswordGateProvider } from '@/components/Shared/PasswordGate';
import { getMediaKitInfoAPIFn, getUserPlanTypeAPIFn } from '@/redux/features/CurrentUser/currentUserSlice';
import { normalizeRole, ROLES } from '@/router/roles';
import { useKitStates } from '@/utils';

export const CreaterDashboardLayout = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { userId } = useKitStates();
  const currentUser = useSelector(state => state?.currentUser?.currentUser);
  const role = normalizeRole(currentUser?.userRole);
  const isCreator = role === ROLES.CREATOR;

  const [isShow, setIsShow] = useState(true);

  const fetchPlan = async () => {
    if (userId) {
      await dispatch(getUserPlanTypeAPIFn({ userId }));
    }
  };
  const fetchData = async () => {
    if (userId) {
      await dispatch(getMediaKitInfoAPIFn({ userId }));
    }
  };

  useEffect(() => {
    if (isCreator) {
      fetchData();
      fetchPlan();
    }

    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsShow(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isCreator, userId]);

  // Open side menu when user navigates from Media Kit (e.g. Back to Dashboard)
  useEffect(() => {
    if (location?.state?.fromMediaKit) {
      setIsShow(true);
    }
  }, [location?.pathname, location?.state?.fromMediaKit]);

  return (
    <React.Fragment>
      <main className='flex w-screen h-screen'>
        {/* Side Menu */}
        <SideMenuDesktop isShow={isShow} setIsShow={setIsShow} />

        <div className={`relative flex flex-col ${isShow ? 'w-full md:w-[calc(100vw-230px)] base:w-[calc(100vw-280px)]' : 'w-full'} `}>
          {/* <Header /> */}
          <Header isSideMenuOpen={isShow} setSideMenuOpen={setIsShow} />
          {/* Body */}
          <div className='overflow-y-auto w-full h-[calc(100vh-80px)] md:h-[calc(100vh-110px)] p-2 overflow-x-hidden'>
            <PasswordGateProvider>{children}</PasswordGateProvider>
          </div>

          {isShow ? (
            <div
              className='absolute top-0 left-0 right-0 w-screen h-screen bg-black/60 md:hidden'
              onClick={() => setIsShow(false)}
            />
          ) : null}
        </div>
      </main>
    </React.Fragment>
  );
};

